import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import StarfieldBackground from "../components/starfield-background";
import Navigation from "@/components/navigation";
import HeroSection from "../components/hero-section";
import GamesSection from "../components/games-section";
import TournamentSection from "../components/tournament-section";
import Footer from "../components/footer";
export default function Home() {
    return (_jsxs("div", { className: "min-h-screen bg-black text-white relative", children: [_jsx(StarfieldBackground, {}), _jsx("div", { className: "nebula-bg", style: {
                    backgroundImage: "url('https://images.unsplash.com/photo-1502134249126-9f3755a50d78?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&h=1080')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    opacity: 0.3
                } }), _jsxs("div", { className: "relative z-10", children: [_jsx(Navigation, {}), _jsx(HeroSection, {}), _jsx(GamesSection, {}), _jsx(TournamentSection, {}), _jsx(Footer, {})] })] }));
}
